import { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'components/generic';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFetch } from 'hooks';
import { OnboardingContext } from 'providers/onboarding-provider';
import Images from 'assets/Images';
import './style.scss';

const Verification = () => {
	const context = useContext(OnboardingContext);
	const { emailStatus, setEmailStatus } = context;
	const [clientConfig, setClientConfig] = useState({ redirectToLogin: true, emailVerificationStatus: false });
	const fetchState = useSelector(state => ({ loader: state?.loader }));

	const search = useLocation().search;
	const api = useFetch();
	const navigate = useNavigate();

	const initVerification = () => {
		const c_id = new URLSearchParams(search).get('c_id');
		const c_token = new URLSearchParams(search).get('c_token');
		!emailStatus && (!c_id || !c_token) && navigate('/');
		c_id && c_token && verify(c_id, c_token);
	};

	const verify = async (c_id, c_token) => {
		try {
			const { data } = await api({ url: `client/v1/verify?c_id=${c_id}&c_token=${c_token}`, method: 'get', hideErrorToaster: true });
			const cc = data?.data;
			setClientConfig(cc);
			setLoginStates(cc);
			setEmailStatus('COM');
		} catch (error) {
			setEmailStatus('ERROR');
		}
	};

	const setLoginStates = params => {
		localStorage.setItem('c_id', params?.c_id);
		localStorage.setItem('_ac', params?.access?.access_token);
		localStorage.setItem('_sc', params?.access?.session_state);
		localStorage.setItem('_rc', params?.access?.refresh_token);
	};

	const handleOnboarding = () => {
		navigate(!clientConfig?.redirectToLogin && clientConfig?.emailVerificationStatus ? '/onboarding' : '/');
	};

	useEffect(() => {
		initVerification();
	}, []);

	return (
		!fetchState?.loader?.isLoading && (
			<div className='layout-wrap'>
				<div className='verify'>
					<div className='verify__header'>
						<img src={Images?.loginLogo} alt='App logo' width='30px' height='30px' />
						<h4>{process.env.REACT_APP_NAME}</h4>
					</div>
					<div className='verify__box'>
						<div className='verify__info'>
							<img src={Images.email_verified} />
							<h4>{emailStatus === 'PEN' ? 'Verify your e-mail to continue onboarding process!' : clientConfig?.message || 'Something went wrong! Please try again'}</h4>
							<Button label={clientConfig?.redirectToLogin ? 'Back to Login' : clientConfig?.emailVerificationStatus ? 'Start Onboarding' : 'Back To Login'} primary medium handleOnSubmit={handleOnboarding} />
						</div>
					</div>
				</div>
			</div>
		)
	);
};

export default Verification;
